
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"clip-rule":"evenodd","fill-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2","viewBox":"0 0 20436 20436","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#1b2033"}},[_c('path',{attrs:{"d":"M10216.8 0C15857.14 0 20436 4578.59 20436 10218c-.001 5639.38-4578.84 10218-10219.2 10218C4578.89 20436 0 15857.41 0 10218 0 4578.62 4578.84 0 10216.8 0zm0 2554.36c4231.5 0 7663.78 3433.88 7663.78 7663.59 0 4229.47-3432.31 7663.34-7663.78 7663.34-4229.03 0-7661.34-3433.88-7661.34-7663.34 0-4229.72 3432.31-7663.59 7661.34-7663.59z"}}),_c('path',{attrs:{"d":"M7032.38 10217.8H5139.61v356.137c0 2942.1 2280.41 5322 5078.12 5322 2797.6 0 5078.12-2379.91 5078.12-5322V10217.8h-1892.77v356.137c0 1854.17-1422.25 3368.25-3185.34 3368.25-1763.12 0-3185.38-1514.09-3185.38-3368.25V10217.8h.003z"}})])])
          )
        }
      }
    